import React, { useEffect, useRef, useState } from "react";
import styles from "./dashboard.module.css";
import { Outlet } from "react-router-dom";
import SideBar from "../../Components/Common/SideBar";
import TopBar from "../../Components/Common/TopBar";
import SideBarSubMenu from "../../Components/Common/SideBarSubMenu";
import { useDispatch, useSelector } from "react-redux";
import { allCountry } from "../../Store/Slices/getCountrySlice";

function Dashboard() {
  const [subMenus, setSubMenus] = useState([]);
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.country);

  const handleActiveMenu = (menus) => {
    // console.log("menus", menus);
    let ActiveMenu = menus.filter(
      (menu) => menu.isActive === true && menu.submenus
    );
    // if (ActiveMenu.length && ActiveMenu[0].submenus[0].accordion!==false) {
    //  ActiveMenu[0].submenus[0].menu[0].isActive=true
    // }
    // console.log("ActiveMenu", ActiveMenu);
    setSubMenus(ActiveMenu);
    if (ActiveMenu.length) {
      setSubMenuToggle(true);
    } else {
      setSubMenuToggle(false);
    }
  };
  const handleActiveSubMenu = (menus) => {
    // console.log("menus", menus);
    // console.log("subMenus", subMenus);
    const updatedSubMenu = subMenus[0].submenus.map((m) => {
      if (menus.accordion === m.accordion) {
        m.isActive = true;
        const menu = m.menu.map((item) => {
          if (item.id === menus.menu.id) {
            item.isActive = true;
          } else {
            item.isActive = false;
          }
        });
      } else {
        m.isActive = false;
      }
      return m;
    });

    // console.log("updatedSubMenu", updatedSubMenu);
    subMenus[0].submenus = updatedSubMenu;
    setSubMenus(subMenus);
  };
  const [sideBar, setSideBard] = useState(true);
  const handleSideBar = () => {
    // console.log("sideBar",sideBar);

    if (subMenutoggle && subMenutoggle) {
      setSubMenuToggle(false);
    } else {
      setSideBard(!sideBar);
    }

    if (subMenutoggle) {
      setSubMenuToggle(false);
    }
  };

  const subMenuRef = useRef(null);
  const [subMenutoggle, setSubMenuToggle] = useState(false);
  const hideOutsideClick = (event) => {
    if (subMenuRef.current && !subMenuRef.current.contains(event.target)) {
      setSubMenuToggle(true);
    }
  };

  // useEffect(() => {
  //   document.addEventListener('mousedown', hideOutsideClick);

  //   return () => {
  //     document.removeEventListener('mousedown', hideOutsideClick);
  //   };
  // }, []);

  useEffect(() => {
    if (!data?.length) {
      dispatch(allCountry()); // Fetch countries if not available in the persisted state
    }
  }, [dispatch, data]);

  return (
    <section>
      <div className={styles.dashboard}>
        <TopBar handleSideBar={handleSideBar} />
        <div className={styles.main}>
          <div
            ref={subMenuRef}
            className={
              sideBar
                ? [`${styles.sidebar} ${styles.sidebarShow}`]
                : [`${styles.sidebar} ${styles.sidebarHide}`]
            }
          >
            <SideBar handleActiveMenu={handleActiveMenu} />
            {subMenutoggle ? (
              <div className={styles.subMenu}>
                {Boolean(subMenus.length) ? (
                  <SideBarSubMenu
                    handleActiveSubMenu={handleActiveSubMenu}
                    subMenus={subMenus[0].submenus}
                  />
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
          </div>
          <div className={styles.content}>
            <Outlet />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Dashboard;
